<template>
    <div>
        <input type="checkbox" class="checkbox" v-model="stageValue" :value="stage.id" @change="changeStageValue">
        <span class="label_title ">{{stage.name}}</span>
    </div>
</template>

<script>
export default {
    props: ['stage'],
    data() {
        return {
            stageValue: ''
        }
    },
    methods: {
        changeStageValue() {
            this.$emit('stageValue', this.stage.id)
        }
    }
}
</script>

<style>

</style>